import api from '@/api/ks/courseContent/order.js'
const state = {
	orderInfo: {
		list: [],
		total: 0,
		order_all: 0,
		order_author_all: 0
	}
}
const mutations = {
	getOrderInfoState(state, data) {
		state.orderInfo =  {
			list: data.list,
			total: data.page_info.total_count,
			order_all: data.order_all || 0,
			order_author_all: data.order_author_all || 0
		}
	}
}
const actions = {
	getOrderInfo({ commit }, params = {}) {
		api.getOrderInfo(params, (res) => {
			commit('getOrderInfoState', res)
		})
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}